"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ__Div = exports.Occ_ButtonService = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_ButtonService = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding: var(--spacing-none);\n    margin: var(--spacing-none);\n    font-size: var(--font-size-xs);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    max-width: 80px;\n    cursor: pointer;\n    background: none;\n    border: none;\n    position: relative;\n"])));
exports.Occ_ButtonService = Occ_ButtonService;
var Occ__Div = (0, _styledComponents["default"])('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: var(--color-green-500);\n    padding: 0 8px;\n    border-radius: var(--border-radius-xs);\n    position: absolute;\n    top: 40px;\n"])));
exports.Occ__Div = Occ__Div;